import React, { Component } from 'react'
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Loader } from "react-overlay-loader";

class UploadDocument extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fileRequired: {
        filename: '',
        path: ''
      },
      potong_pajak: 'Y',
      success: '',
      error: [],
      user: JSON.parse(window.localStorage.getItem('is_user'))
    }
  }

  componentDidMount = () => {
    this.detailAssignment()
  }

  detailAssignment = () => {
    let {fileRequired} = this.state
    let { id } = this.props.match.params;
    let url = '/api/traces_chd/v1/assignment/detail'
    let param = {
      program_customer_id: id
    }
    request.postCHD(url, param, {
      success: function(response) {
        let {data} = response.data
        fileRequired.filename = data.header.document_filename
        fileRequired.path = data.header.document_path
        this.setState(fileRequired)
        this.setState({ potong_pajak: (data.header.potong_pajak) ? data.header.potong_pajak : 'Y'})
      }.bind(this),
      error: function(e) {

      }.bind(this)
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  removeFile = () => {
    let {fileRequired} = this.state
    fileRequired.filename = ''
    fileRequired.path = ''
    this.setState(fileRequired)
  }

  renderFileUpload = () => {
    let { fileRequired } = this.state
    if (fileRequired.filename && fileRequired.filename.length > 0) {
      return (
        <span>
          <a href={fileRequired.path} target="_blank">{fileRequired.filename}</a>&nbsp; <button type="button" className="btn btn-danger" onClick={this.removeFile.bind(this)}><i className="fa fa-trash" /></button>
        </span>
      )
    } else {
      return (
        <span>
          <input type="file" className="form-control" onChange={this.handleUploadSingle.bind(this)} />
        </span>
      )
    }
  }

  renderFormUpload = () => {
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="form-group row">
            <label className="col-md-4">Upload Document</label>
            {this.renderFileUpload()}
          </div>
          <div className="form-group">
            <label>Bersedia Potong Pajak</label>
            <div>
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" checked={this.state.potong_pajak === 'Y'} value="Y" onClick={this.handleInputChange.bind(this)} name="potong_pajak" />Ya
              </label>
              </div>
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" checked={this.state.potong_pajak === 'N'} value="N" onClick={this.handleInputChange.bind(this)} name="potong_pajak" />Tidak
              </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderButton = () => {
    return (
      <div className="row">
        <div className="col-md-3">
          <button className="btn btn-primary btn-block" type="button" onClick={this.handleSubmit.bind(this)} ><i className="fa fa-save" /> Submit</button>
        </div>
        <div className="col-md-3">
          <button className="btn btn-primary btn-warning btn-block" type="button" onClick={() => { this.props.history.push('/admin/assignment-chd/summary-all')}} ><i className="fa fa-arrow-left" /> Back</button>
        </div>
      </div>
    )
  }

  validationForm = () => {
    let error = []
    let { potong_pajak, fileRequired } = this.state
    if (fileRequired.filename.length === 0) {
      error.push('File is required')
    }
    if (error.length > 0) {
      this.setState({ error: error })
      return false
    } else {
      return true
    }
  }

  handleSubmit = () => {
    let { fileRequired, potong_pajak, user } = this.state
    if (this.validationForm()) {
      let { id } = this.props.match.params;
      let url = '/api/traces_chd/v1/assignment/upload-doc'
      let param = {
        file: {
          filename: fileRequired.filename,
          path: fileRequired.path
        },
        potong_pajak: potong_pajak,
        program_customer_id: id,
        user_id: user.user_id
      }
      this.setState({ loading: true })
      request.postCHD(url, param, {
        success: function (response) {
          let { message } = response.data
          this.setState({ loading: false, success: message })

          let app = this
          window.setTimeout(() => {
            app.props.history.push('/admin/assignment-chd/summary-all')
          }, 2000)
        }.bind(this),
        error: function (e) {
          let msg = e.response.data ? e.response.data.message : e.message
          this.setState({ loading: false, error: [msg] })
        }.bind(this)
      })
    }
  }

  handleInputChange = (e) => {
    let name = e.target.name
    let value = e.target.value

    this.setState({ [name]: value })
  }

  handleUploadSingle = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = ["jpg", "png", "jpeg", "gif", "doc", "docx", "xls", "xlsx", "csv", "pdf"];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyCHD("/api/traces_chd/v1/util/upload-file", data, {
      success: function (response) {
        let data = response.data;
        let { fileRequired } = this.state;
        fileRequired.filename = data.filename;
        fileRequired.path = data.fullurl;
        this.setState(fileRequired);
        this.setState({ loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
        console.log(e.message)
      }.bind(this),
    });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <form className="form-horizontal">
                  <div className="card card-info">
                    <div className="card-body">
                      {this.showNotification()}
                      {this.renderFormUpload()}
                      {this.renderButton()}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default UploadDocument